export default "__VITE_ASSET__CnIDehmE__"